query UserRankTypesModal {
  userRankTypes(orderBy: USER_RANK_ASC) {
    nodes {
      id
      _rowTimestamp
      userRank
      sortOrder
      _isUpdatable
      _isDeletable
    }
  }
}
